import { HttpVerb } from "../../constants";

const getSessionTime = async () => {
  return window.ucSDK.api.instance?.authenticatedRequest({
    url: "/api/Timing/GetSessionTime/",
    method: HttpVerb.GET
  });
};

export default {
  getSessionTime
};
